/* eslint-disable no-unused-vars */
/* eslint-disable prettier/prettier */
import cabine from '../../../services/cabineApi';
import { gotErrorFromApi } from '../../../utils/api';
import {
  disableCashInFromApi,
  getcashInFromApi,
  gotcashInFromApi as gotcashInAnalyticFromApi,
  gotErrorFromcashInApi,
} from '../../duck/legado/cashin/analyticData';
import {
  getcashInDownloadFromApi,
  gotcashInDownloadFromApi,
  gotErrorFromcashInDownloadApi,
} from '../../duck/legado/cashin/downloadData';
import {
  disableCashInFromApi as disableCashInFromApiSynthetic,
  getSyntheticReportFromApi,
  gotErrorFromSyntheticReportApi,
  gotSyntheticReportFromApi,
} from '../../duck/legado/cashin/syntheticData';
import { SendLoginTokenAuth } from '../tokens';

export default function getCashInData(
  initialDate: string,
  finalDate: string,
  type: string,
  partner: string
) {
  return (dispatch: any) => {
    if (initialDate !== '' && finalDate !== '') {
      dispatch(disableCashInFromApi());
      dispatch(disableCashInFromApiSynthetic());
      if (type === 'sintetico') {
        dispatch(getSyntheticReportFromApi());
      } else {
        dispatch(getcashInFromApi());
      }

      cabine
        .get(
          `/v1/legado/tarifacao/${type}/${partner}/${initialDate}/${finalDate}`,
          SendLoginTokenAuth()
        )
        .then((response: any) => {
          if (type === 'sintetico') {
            dispatch(gotSyntheticReportFromApi(response.data));
          } else {
            dispatch(gotcashInAnalyticFromApi(response.data));
          }
        })
        .catch((error: any) => {
          if (type === 'sintetico') {
            gotErrorFromApi(error, dispatch, gotErrorFromcashInApi);
          } else {
            gotErrorFromApi(error, dispatch, gotErrorFromSyntheticReportApi);
          }
        });
    }
    return false;
  };
}

export function getCashInDataExcel(
  initialDate: string,
  finalDate: string,
  type: string,
  partner: string
) {
  return (dispatch: any) => {
    if (initialDate !== '' && finalDate !== '') {
      dispatch(getcashInDownloadFromApi());

      cabine
        .get(
          `/v1/legado/tarifacao/${type}/download/${partner}/${initialDate}/${finalDate}`,
          SendLoginTokenAuth()
        )
        .then((response: any) => {
          window.open(response.data.path, '_blank');
          dispatch(gotcashInDownloadFromApi(response.data));
        })
        .catch((error: any) => {
          gotErrorFromApi(error, dispatch, gotErrorFromcashInDownloadApi);
        });
    }
    return false;
  };
}
